import { render, staticRenderFns } from "./fileIcon.vue?vue&type=template&id=1fd970ec&"
import script from "./fileIcon.vue?vue&type=script&lang=js&"
export * from "./fileIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports